<div class="container-flex">
  <div class="tabla-container">
    <app-tabla
      [totalCount]="totalCount"
      [datos]="logHttp"
      [columnas]="columnas"
      [name]="name"
      [pageSizeOptions]="helper.pageSizeOptions"
      [search]="search"
      [(query)]="query"
      (queryChange)="listar()"
      [paginatorArriba]="false"
      [filtros]="filtros"
      [emptyState]="{ title: 'Todavía no hay requests HTTP' }"
    ></app-tabla>
  </div>

  @if (logHttpSeleccionado) {
    <div class="detalles-container">
      <app-detalles-request-http
        [title]="'Detalles Request HTTP - ID: ' + logHttpSeleccionado._id"
        [data]="logHttpSeleccionado"
        (close)="cerrarDetalles()"
      ></app-detalles-request-http>
    </div>
  }
</div>
